// extracted by mini-css-extract-plugin
export default {"rowHasBadge":"WB-z","smallCardRow":"XB-z","largeCardRow":"YB-z","productSearchRow":"ZB-z","curatedRow":"_B-z"};